import React, { useMemo } from 'react';

import { useIntl } from 'react-intl-next';

import AvatarIcon from '@atlaskit/icon/core/person-avatar';

import type {
	ButtonItemConfig,
	ForYou,
	ForYouConfig,
	ForYouHidden,
	LinkItemConfig,
	NavItemConfigInternal,
} from '../../common/types';

import { FOR_YOU_TEST_ID } from './constants';
import { messages } from './messages';

const elemBefore = <AvatarIcon label="" />;

export function useForYouNavItem(forYou: ForYouConfig): [string, NavItemConfigInternal][] {
	const { formatMessage } = useIntl();
	// Some type magic so we can get the dependencies right for the memo and keep TypeScript happy.
	// Only use this constant when `forYou.hideForYou` is false.
	const forYouShown = forYou as Exclude<ForYou, ForYouHidden>;

	return useMemo(() => {
		if (forYou.hideForYou) {
			return [];
		} else {
			const common = {
				elemBefore,
				label: formatMessage(messages.label),
				isSelected: forYouShown.forYouIsSelected,
				testId: FOR_YOU_TEST_ID,
				isHideable: false,
				isReorderable: false,
			};

			const value: LinkItemConfig | ButtonItemConfig = forYouShown.forYouUrl
				? {
						type: 'link',
						href: forYouShown.forYouUrl,
						onClick: forYouShown.forYouOnClick,
						...common,
					}
				: {
						type: 'button',
						onClick: forYouShown.forYouOnClick,
						...common,
					};

			return [[forYouShown.forYouMenuItemId ?? 'global.sidebar.forYou', value]];
		}
	}, [
		forYou.hideForYou,
		forYouShown.forYouIsSelected,
		forYouShown.forYouMenuItemId,
		forYouShown.forYouOnClick,
		forYouShown.forYouUrl,
		formatMessage,
	]);
}
